const r=()=>({style:{},transform:{},transformOrigin:{},vars:{}});export{r as createHtmlRenderState};
